module.exports = __webpack_public_path__ + "img/example-daily-menu-arrows.e788ae50.png";